// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610070018/js/" + chunkId + "." + {"44":"d8a253bb","225":"8bbae416","481":"45aea4fc","486":"23c28e0a","770":"6b6087a1"}[chunkId] + ".0.29594462350633277.chunk.js";
};